export interface Currency {
    code: CurrencyCode;
    name: string;
    symbol: string;
}

export const currencies: Currency[] = [{
    code: "EUR",
    name: "Euro",
    symbol: "€"
},
    {
        code: "CHF",
        name: "Schweizer Franken",
        symbol: "CHF"
    }];

type CurrencyCode = "EUR" | "CHF";

const useCurrency = () => {
    const getSymbol = (code?: CurrencyCode): string => {
        return currencies.find((currency) => currency.code === code)?.symbol || "€";
    };

    return { currencies, getSymbol };
};

export default useCurrency;